import React, { useState } from 'react';
import './LandingPage.css';
import { useAuth } from './auth';
import news1 from './news/news1.md.js';
import news2 from './news/news2.md.js';
import news3 from './news/news3.md.js';
import news4 from './news/news4.md.js';
import article01 from './news/article01.md.js';
import article02 from './news/article02.md.js';
import article03 from './news/article03.md.js';
import article04 from './news/article04.md.js';

const IconRenderer = ({iconName}) => {
   return <>No image for {iconName}</>;
};

const features = [
  {
    key: 'fittracker',
    title: 'FitTracker',
    description: 'Track goals, progress, and client profiles in a demo environment.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fittracker_icon.png',
    route: '/clients/example/dashboard',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'scheduler',
    title: 'Session Scheduling Tool',
    description: 'Organize sessions and manage availability with ease.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/scheduler_icon.png',
    route: '/clients/example/schedulingavailability',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'workoutprogramming',
    title: 'Workout Programming',
    description: 'Build and browse workout routines and exercises.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/programmer_icon.png',
    route: '/workoutlibrary',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'messages',
    title: 'Messaging',
    description: 'Communicate securely with clients and trainers.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/messages_icon.png',
    route: '/messages',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'payments',
    title: 'Payments',
    description: 'Track and manage payments for sessions and services.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/payments_icon.png',
    route: '/clients/example/payments',
    button: 'View Demo',
    type: 'Demo',
  },
];



function Row({ children }) {
  return <div className="feature-card-row"
    style={{display:'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        width: "100%",
    }}>{children}</div>;
}

function Col({ children }) {
  return <div className="feature-card-col"
    style={{display:'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        flex: 1,
        minWidth: 0
    }}
    >{children}</div>;
}

function FeatureCard({
  title,
  description,
  image,
  iconName,
  button,
  onClick,
  link,
  form,
  qr,
  type,
  badge,
  children,
  articleText,
  articleUrl,
  imageUrl,
  mutedText,
}) {

  const titleWithoutHashtags = title ? title.replace(/#/g, '') : null;

  const trimmedArticleText1 = articleText && articleText.length > 200
    ? articleText.substring(0, 200) + '...'
    : articleText;

  // Get the date - it is the second line.
  const articleDate = articleText ? articleText.split('\n')[1] : null;

  const articleDateWithNoAsterisks = articleDate ? articleDate.replace(/\*/g, '') : null;

  // REmove the first two lines since it is the title 
  const trimmedArticleText2 = articleText && articleText.length > 200
    ? articleText.split('\n').slice(2).join('\n').substring(0, 200) + '...'
    : articleText;

  // Also remove all hashtags `#` no matter how many 
  const trimmedArticleText = trimmedArticleText2 ? trimmedArticleText2.replace(/#/g, '') : null;  

  return (
    <div className={`feature-card`}>
      <Row>
        <Col>
          {!iconName && !qr && (
            <div
              className="feature-card-cover"
              style={{
                backgroundImage: `url(${image || imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
              role="img"
              aria-label={titleWithoutHashtags}
            >
              <div className="feature-card-cover-overlay" />
              {/* <div className="feature-card-badge" title={titleWithoutHashtags}>
                {badge || (titleWithoutHashtags && titleWithoutHashtags.split(' ')[0])}
              </div> */}
            </div>
          )}
          {iconName && <IconRenderer iconName={iconName} />}
          {qr && (
            <div style={{ marginTop: 16 }}>
              <img
                src={qr}

                width="100%"
                alt="QR Code"
                className="landing-page-qr-code"
              />
            </div>
          )}
        </Col>
        <Col>
          {type && (
            <div className="feature-card-type">{type.toUpperCase()}</div>
          )}
          <div className="feature-card-body">
            <div className="feature-card-title">{titleWithoutHashtags}</div>
            <div>
              {articleDate && (
                <strong>{articleDateWithNoAsterisks}</strong>
              )}
            </div>
            <div className="feature-card-description">
              {description}
              {articleText && (
                <div style={{ marginTop: 8 }}>
                  <div className="news-preview-text">{trimmedArticleText}</div>
                </div>
              )}
            </div>
            {children}
            {form ? (null) : link ? (
              <a
                href={link || articleUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
                className="feature-card-button"
              >
                {button || 'Read More'}
              </a>
            ) : button ? (
              <button
                className="feature-card-button"
                onClick={onClick}
              >
                {button}
              </button>
            ) : null}
            {mutedText && (
              <div className="landing-page-muted-text">{mutedText}</div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

const VIDEO_DEMO_URL = 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/ptc_explainer_draft.MOV';

export function UnfinishedToolsList() {
  const [showForm, setShowForm] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const { user } = useAuth();


  return (
    <div className="landing-page-container fogged-card">
      <h1 className="landing-page-title">Future Tools</h1>
      <p className="landing-page-description">
        These are conceptual nonfunctional tool idea/concept demos,
         planned for future development.<br /><br />
         Check them out if you would like to send me feedback on them!<br /><br />
        Do not use these tools as they are not yet implemented.<br />
      </p>
      {/* Responsive grid of feature cards */}
      <div className="landing-page-features-grid">
        {features.map((feature) => (
          <FeatureCard
            key={feature.key}
            title={feature.title}
            description={feature.description}
            image={feature.image}
            iconName={feature.iconName}
            button={feature.button}
            onClick={feature.onClick ? feature.onClick : () => (window.location.href = feature.route)}
            type={feature.type}
            badge={feature.title.split(' ')[0]}
          />
        ))}
      </div>

    </div>
  );
}